export default __webpack_public_path__ + "static/media/illustration-work-1-w@3x.f094159e.webp";